import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ErrorBoundary from "../../../ErrorBoundary";
import { OnboardingProgressDiv } from "../Onboarding/OnboardingProgressDiv";
import { OnvifScanScreen } from "./OnvifScanScreen";
import { useOnvifScanStore } from "./onvifScanStore/onvifScanStore";

/** Half of the prior 1600px discovery shell; progress returns to Add Site width. */
const DISCOVERY_PANEL_WIDTH_PX = 800;
const PROGRESS_PANEL_WIDTH_PX = 600;

export const OnvifDiscoveryOnboarding = () => {
  const navigate = useNavigate();
  const { siteId: siteIdParam } = useParams<{ siteId: string }>();
  const siteId = siteIdParam || localStorage.siteId || "";
  const resetScan = useOnvifScanStore((state) => state.reset);

  const navigateToNewSite = React.useCallback(() => {
    localStorage.setItem("cameraNumber", "1");
    if (siteId) {
      navigate(`/sites/aboutsite/${siteId}`);
    } else {
      navigate("/sites");
    }
  }, [navigate, siteId]);

  const [largerScreen, setLargerScreen] = React.useState(true);
  const [visibleScreen, setVisibleScreen] = React.useState(<></>);

  React.useEffect(() => {
    resetScan();
    setLargerScreen(true);
    setVisibleScreen(
      <OnvifScanScreen
        variant="onboarding"
        siteIdOverride={siteId}
        onNoTunnels={navigateToNewSite}
        onSuccess={() => {
          setLargerScreen(false);
          setVisibleScreen(
            <OnboardingProgressDiv
              percentage={66}
              step={2}
              setVisibleScreen={setVisibleScreen}
            />
          );
        }}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId]);

  const panelWidth = largerScreen
    ? DISCOVERY_PANEL_WIDTH_PX
    : PROGRESS_PANEL_WIDTH_PX;

  return (
    <ErrorBoundary>
      <div>
        <div className="bg-black fixed w-full h-full opacity-90">
          <div className="bg-black fixed w-full h-full opacity-10 pointer-events-none"></div>
          <div className="flex justify-end text-left">
            <div
              className="absolute top-[50px] h-full bg-white"
              style={{ width: panelWidth }}
            ></div>
          </div>
        </div>
        <div className="flex justify-end text-left">
          <div
            className="absolute h-full bg-white overflow-y-auto"
            style={{ width: panelWidth }}
          >
            <div
              className="bg-actuate-blue absolute h-[50px] z-10"
              style={{ width: panelWidth }}
            >
              <button
                className="absolute right-6 top-[10px] text-white text-[18px]"
                onClick={navigateToNewSite}
              >
                X
              </button>
              <div className="text-white absolute top-[1px] left-3 font-mulish text-[18px] p-3">
                ONVIF Camera Discovery
              </div>
            </div>
            <div className="pt-[50px]">{visibleScreen}</div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};
